// extracted by mini-css-extract-plugin
export var button = "FileDownload-module--button--ylJR8";
export var filename = "FileDownload-module--filename--Up97+";
export var wrapper = "FileDownload-module--wrapper--5MKHl";